export enum ConnectionMediumOrigin {
    VEHICLE = 1,
    STOP = 2
}